// src/components/SellerInvite/RedeemInvite.jsx
// "Canjear código de invitación" para convertirse en vendedor verificado, desde una
// cuenta ya logueada (cierra el hueco: los usuarios de wallet no ingresan código al
// registrarse). Se auto-oculta si el usuario ya está verificado.
import React, { useState } from 'react';
import { FiAward, FiCheckCircle, FiArrowRight } from 'react-icons/fi';
import { useAuth } from '../../Context/AuthContext';
import './RedeemInvite.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';

export default function RedeemInvite() {
  const { user, updateUser } = useAuth();
  const [code, setCode]     = useState('');
  const [loading, setLoad]  = useState(false);
  const [error, setError]   = useState('');
  const [done, setDone]     = useState(false);

  if (user?.verified) return null; // ya es vendedor verificado

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (!code.trim()) { setError('Ingresá tu código.'); return; }
    setLoad(true);
    try {
      const res  = await fetch(`${API_URL}/api/redeem-invite`, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token')}` },
        body:    JSON.stringify({ code: code.trim() }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.message || 'No se pudo canjear el código.');
      updateUser(data.user || { verified: true });
      setDone(true);
    } catch (err) {
      setError(err.message === 'Failed to fetch' ? 'No se pudo conectar al servidor.' : err.message);
    } finally {
      setLoad(false);
    }
  };

  if (done) {
    return (
      <div className="ri ri-done">
        <FiCheckCircle className="ri-done-ic" />
        <span>¡Listo! Ya sos <strong>vendedor verificado</strong>. Ahora podés publicar ofertas de venta.</span>
      </div>
    );
  }

  return (
    <div className="ri">
      <div className="ri-head">
        <span className="ri-ic"><FiAward /></span>
        <div>
          <h3 className="ri-title">¿Tenés un código de invitación?</h3>
          <p className="ri-sub">Canjealo para convertirte en <strong>vendedor verificado</strong> y publicar ofertas de venta.</p>
        </div>
      </div>
      <form className="ri-form" onSubmit={submit}>
        <input
          className="ri-input"
          placeholder="BETA-XXXXXXXX"
          value={code}
          onChange={e => setCode(e.target.value.toUpperCase())}
          maxLength={14}
          autoCapitalize="characters"
        />
        <button type="submit" className="ri-btn" disabled={loading}>
          {loading ? <span className="ri-spin" /> : <>Canjear <FiArrowRight /></>}
        </button>
      </form>
      {error && <div className="ri-error">{error}</div>}
    </div>
  );
}
